export default __webpack_public_path__ + "static/media/1130.ebf57b01.png";